import { AUTH_CAPABILITY_CARDS } from '../../lib/auth-capability-cards.js';

export function AuthCapabilityGrid() {
  return (
    <div class="pp-auth-capabilities" aria-labelledby="auth-capabilities-heading">
      <h2 id="auth-capabilities-heading" class="pp-auth-capabilities__title">
        Yapabilecekleriniz
      </h2>
      <div class="pp-auth-capabilities__grid" role="list">
        {AUTH_CAPABILITY_CARDS.map((item) => (
          <div
            class="pp-auth-capabilities__card pp-landing-hero-capabilities__card"
            role="listitem"
            key={item.label}
          >
            <div class="pp-landing-hero-capabilities__top">
              <span
                class={`pp-landing-hero-capabilities__icon pp-landing-hero-capabilities__icon--${item.icon}`}
                aria-hidden="true"
              />
              <strong>{item.label}</strong>
            </div>
            <div class="pp-landing-hero-capabilities__body">
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
